export default "<app-create-submission [includeLoggedUser]=\"false\" [isChairView]=\"true\"></app-create-submission>\n";